<template>
  <div>
    <b-modal
      id="modal-updateStatus"
      ref="updateStatus"
      hide-footer
      centered
      title="Modifier le statut d'un article"
    >
      <div class="pl-lg-4">
        <div class="row">
          <div class="col-12">
            <div>
                <center>
              <b-dropdown id="dropdown-1" :text="getText" class="m-md-2">
                <b-dropdown-item @click="selectedStatus = 'delivered'"
                  >Vente / Livraison</b-dropdown-item
                >
                <b-dropdown-item @click="selectedStatus = 'topay'"
                  >En attente de paiement</b-dropdown-item
                >
                <b-dropdown-item @click="selectedStatus = 'default'"
                  >Rétablir le statut par défaut</b-dropdown-item
                >
              </b-dropdown>
                </center>
            </div>
          </div>
        </div>
        <!--  <div class="row">
       
          </div>-->
      </div>

      <hr class="my-4" />
      <!-- Description -->
      <center>
        <b-btn
          type="submit"
          style="background-color: #c2b59b; color: #fff"
          @click="UpdateProductStatus(model.id)"
          >Modifier</b-btn
        >
      </center>
    </b-modal>
  </div>
</template>
<script>
import { put } from "@/mixins/api";
export default {
  name: "ModalUpdateClient",
  data() {
    return {
      modalupd: false,
      model: {
        id: "",
      },
      selectedStatus: undefined,
    };
  },
  computed: {
    getText() {
      return !this.selectedStatus
        ? "Selectionner un statut"
        : this.selectedStatus == "delivered"
        ? "vente/livraison"
        : this.selectedStatus == "topay"
        ? "En attente de paiement"
        : "Statut par défaut";
    },
  },
  methods: {
    setId(id) {
      this.model.id = id;
      this.$refs.updateStatus.show();
    },
    UpdateProductStatus(id) {
      if (!this.selectedStatus) return;
      const model = {
        delivered: this.selectedStatus == "delivered",
        topay: this.selectedStatus == "topay",
      };
      put("product/status/" + id, model).then((resp) => {
        this.$emit("updated");
        this.$refs.updateStatus.hide();
      });

      this.modalupd = true;
    },
  },
  mounted() {},
};
</script>
                        